import React from 'react';

const ThankYouHero = ({ schedule = [] }) => {
  const hasSchedule = Array.isArray(schedule) && schedule.length > 0;

  return (
    <section className="thank-you-section section-one">
      <div className="container">
        <div className="top-heading">
          <h1>
            Thank You...Your Registration Is <span>Confirmed</span>!
          </h1>
          <h4>
            Discover: How in just two hours you can <u>find high-profit deals</u> before the
            competition, and <u>build lasting wealth!</u>
          </h4>
        </div>

        <div className="steps-section">
          <div className="steps-grid">
            <div className="step-column">
              <div className="step-header">
                <h2>Step #1: Add Event To Your Calendar</h2>
              </div>

              <div className="event-times">
                <div className="event-time-group">
                  {hasSchedule ? (
                    schedule.map((item, index) => (
                      <React.Fragment key={item.id || index}>
                        <div className="divider"></div>

                        <div className="time-slot">
                          <h2>{item.heading}</h2>
                          {item.venueName ? <p>{item.venueName}</p> : null}
                          {item.address ? <p>{item.address}</p> : null} 
                        </div>

                        {index === schedule.length - 1 ? <div className="divider"></div> : null}
                      </React.Fragment>
                    ))
                  ) : (
                    <div className="time-slot">
                      <p>Event details will be shared shortly. Please check your email for updates.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="step-column">
              <div className="step-header">
                <h2>Step #2: Watch This!</h2>
              </div>

              <div className="video-section">
                <div className="video-placeholder">
                  <iframe
                    src="https://player.vimeo.com/video/625026316?h=512ad66c19&title=0&byline=0&portrait=0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    style={{ width: '100%', height: '100%', border: 'none' }}
                    title="Registration Video"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
                          <button className="cta-button" aria-label="Add A Guest!">
                  Add A Guest!
                </button>
        </div>
      </div>
    </section>
  );
};

export default ThankYouHero;
